module.exports = __webpack_public_path__ + "static/media/walking_route.233c68f3.svg";